<!-- Spacer -->
<div
  class="ui-vertical-navigation-item-wrapper"
  [ngClass]="item.classes?.wrapper"
></div>
